import { render, staticRenderFns } from "./course_plan.vue?vue&type=template&id=31c0db1e&scoped=true"
import script from "./course_plan.vue?vue&type=script&lang=js"
export * from "./course_plan.vue?vue&type=script&lang=js"
import style0 from "./course_plan.vue?vue&type=style&index=0&id=31c0db1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0db1e",
  null
  
)

export default component.exports